<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" @click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Редактировать продукт
        </div>
        <DataEntryFields :buttonName="'Изменить'" :dataProduct="dataProduct" @apply="apply"/>
    </div>
</template>

<script>
import SVGModalClose from "../../../SVG/SVGModalClose";
import DataEntryFields from "./DataEntryFields";

export default {
    name: "ChangeProduct",
    components: {
        DataEntryFields,
        SVGModalClose
    },
    props: {
        dataProduct: {
            type: Object,
        }
    },
    methods: {
        apply(newData) {
            this.$store.dispatch('adminPanel/products/SAVE_PRODUCTS', newData);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>

</style>
